module.exports = __webpack_public_path__ + "static/sample-27-79f3fc81bf11d7be7a55a4ee6dd5fc8c.png";